<template>
    <div id="app-bar">
        <v-app-bar
            color="cyan darken-1"
            dense
            dark
        >
            <v-app-bar-nav-icon
                v-show="false"
            />
            <v-toolbar-title><strong>Cat4School Registrierung</strong></v-toolbar-title>
            <v-spacer />
            <v-menu
                left
                bottom
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-show="false"
                        icon
                        v-on="on"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                        v-for="n in 5"
                        :key="n"
                        @click="() => {}"
                    >
                        <v-list-item-title>Option {{ n }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
    </div>
</template>

<script>
export default {
    name: 'AppBar'
}
</script>

<style lang="scss" scoped>
    div#app-bar{
        position: sticky;
        top: 0;
        z-index: 1;
    }
</style>